import { Card, Stack, type CardProps, type StackProps } from '@mui/material';
import { styled } from '@mui/material/styles';

type StyledRootProps = {
  hasSidebar?: boolean;
};

const StyledRoot = styled(Card, {
  shouldForwardProp: propName => propName !== 'hasSidebar',
})<StyledRootProps>(
  {
    flexGrow: 1,
    position: 'relative',
    height: '100%',

    '.ModalBody-container': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
  },
  ({ hasSidebar, theme }) =>
    hasSidebar && {
      '.ModalBody-container': {
        borderRight: `1px solid ${theme.palette.divider}`,
      },
    },
);

export type ModalBodyProps = React.PropsWithChildren<{
  toolbar?: React.ReactNode;
  sidebar?: React.ReactNode;
  slotProps?: {
    root?: CardProps;
    content?: Omit<StackProps, 'className'>;
  };
}>;

export const ModalBody = (props: ModalBodyProps) => {
  const { toolbar, sidebar, slotProps, children } = props;

  return (
    <StyledRoot hasSidebar={!!sidebar} {...slotProps?.root}>
      <Stack {...slotProps?.content} className="ModalBody-container">
        {toolbar}
        {children}
      </Stack>
      {sidebar}
    </StyledRoot>
  );
};
